import Nav from "./Sections-Home/nav";

export default function FAQ() {

    return (
        <Nav />
    );
}